// extracted by mini-css-extract-plugin
module.exports = {"slabDiv":"AddCommission-module--slabDiv--1vtxZ","slabContainer":"AddCommission-module--slabContainer--1Ztkc"};